import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Context from '../../../utils/context';

import styles from '../questionnaire.module.css';

export default function PostSurveyThankYou() {
  const context = useContext(Context);
  const homePath = context.auth.isLoggedIn() ? '/member/conversations' : '/member/login';

  return (
    <div className='row'>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <p className={styles.thank_you}>Thank you!</p>
        <p className={styles.thank_you_p}>
          Your feedback is invaluable to us. With it, we can continue to improve the platform and experience for
          patients everywhere.
        </p>
        <Link to={homePath}>
          <button className={styles.thank_you_button}>Home</button>
        </Link>
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
